<!--
 * @Author: WGL
 * @Date: 2022-04-16 11:34:59
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-04 17:27:39
 * @Description: 
-->
<template>
  <div class="rich-text-wrapper">
    <template v-if="editContent">
      <jwt-editor v-model="contentHtml" :upload-url="uploadRichTextUrl" />
      <div class="mt15">
        <el-button type="primary" @click="handleSubmitContent">
          {{ t('保存') }}
        </el-button>
      </div>
    </template>
    <div
      v-else
      class="w-e-text-container"
      @click="handleImageClick"
      v-html="contentHtml"
    ></div>

    <!-- 图片预览组件 -->
    <el-image-viewer
      v-if="imageViewerVisible"
      :initial-index="currentImageIndex"
      :url-list="imageList"
      :z-index="9999"
      @close="handleCloseImageViewer"
    />
  </div>
</template>

<script>
  import {
    defineComponent,
    onBeforeMount,
    reactive,
    toRefs,
    ref,
    watch,
    nextTick,
    watchEffect,
  } from 'vue'
  import request from '@/utils/request'
  import { uploadRichTextUrl } from '@/config/index'
  import { t } from '@/utils/i18n'

  // import dayjs from 'dayjs'
  export default defineComponent({
    name: 'RichTextView',
    components: {},
    props: {
      contentId: { type: [String, Number], default: '' },
      content: { type: String, default: '' },
      editContent: { type: Boolean, default: false }, // 是否内容可编辑
    },
    emits: ['save'],
    setup(props, { emit }) {
      const state = reactive({
        contentHtml: '',
      })

      // 图片预览相关状态
      const imageViewerVisible = ref(false)
      const currentImageIndex = ref(0)
      const imageList = ref([])

      // 获取详情
      const getContentDetail = () => {
        console.log('getContentDetail', props)
        const id = props.contentId
        if (props.content) {
          state.contentHtml = props.content
          return
        }
        if (!id) return
        request({
          url: `/story/detail`,
          method: 'get',
          params: {
            id,
          },
        }).then((res) => {
          console.log('getContentDetail res', res)
          state.contentHtml = res.content
        })
      }

      const handleSubmitContent = () => {
        const id = props.contentId
        if (!id) {
          emit('save', state.contentHtml)
        }
        request({
          url: `/story/edit`,
          method: 'post',
          data: {
            id,
            content: state.contentHtml,
          },
        })
      }

      // 处理图片点击事件
      const handleImageClick = (event) => {
        const target = event.target
        if (target.tagName === 'IMG') {
          event.preventDefault()
          event.stopPropagation()

          // 获取当前富文本容器中的所有图片
          const richTextContainer = event.currentTarget
          const images = richTextContainer.querySelectorAll('img')
          const imageArray = Array.from(images)

          // 找到当前点击的图片索引
          const currentIndex = imageArray.findIndex((img) => img === target)

          // 提取所有图片的src
          const srcList = imageArray.map((img) => {
            const src =
              img.src || img.getAttribute('data-src') || img.getAttribute('src')
            return src
          })

          // 过滤掉无效的图片链接
          const validSrcList = srcList.filter(
            (src) => src && src !== 'null' && src !== 'undefined' && src !== ''
          )

          if (validSrcList.length > 0) {
            imageList.value = validSrcList
            currentImageIndex.value = currentIndex >= 0 ? currentIndex : 0
            imageViewerVisible.value = true
          }
        }
      }

      // 关闭图片预览
      const handleCloseImageViewer = () => {
        imageViewerVisible.value = false
      }

      // 为图片添加样式和点击事件
      const setupImageStyles = () => {
        nextTick(() => {
          const richTextContainer = document.querySelector('.rich-text-wrapper')
          if (richTextContainer) {
            const images = richTextContainer.querySelectorAll('img')
            images.forEach((img) => {
              // 添加样式
              img.style.cursor = 'pointer'
              img.style.transition = 'opacity 0.3s ease'

              // 添加 hover 效果
              img.addEventListener('mouseenter', () => {
                img.style.opacity = '0.8'
              })
              img.addEventListener('mouseleave', () => {
                img.style.opacity = '1'
              })
            })
          }
        })
      }

      onBeforeMount(() => {
        getContentDetail()
      })
      watchEffect(() => {
        getContentDetail()
      })
      // 监听内容变化，重新设置图片样式
      watch(
        () => state.contentHtml,
        (newContent) => {
          if (!props.editContent && newContent) {
            setupImageStyles()
          }
        }
      )

      return {
        ...toRefs(state),
        uploadRichTextUrl,
        handleSubmitContent,
        imageViewerVisible,
        currentImageIndex,
        imageList,
        handleImageClick,
        handleCloseImageViewer,
        t,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .rich-text-wrapper {
    width: 100%;
    :deep() {
      video {
        width: 100% !important;
      }
      blockquote {
        line-height: 1.5;
        margin: 10px 0;
        padding: 10px;
        background-color: #f5f2f0;
        border-left: 8px solid #b4d5ff;
      }
      img {
        max-width: 100%;
        cursor: pointer;
        transition: opacity 0.3s ease;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
</style>
